(() => {
 if(window.ntDescriptionPhotoBound)return;
 window.ntDescriptionPhotoBound=true;
 document.addEventListener('click',event=>{
  const button=event.target.closest?.('[data-nt-desc-photo]');
  if(!button)return;
  const root=button.closest('[data-nt-product]');
  const photos=root?.querySelectorAll('[data-nt-product-thumb]:not([data-nt-360-thumb])');
  const photo=photos?.[Number(button.dataset.ntDescPhoto)];
  const zoom=root?.querySelector('[data-nt-media-zoom]');
  if(!zoom)return;
  if(photo)photo.click();else if(Number(button.dataset.ntDescPhoto)!==0)return;
  zoom.click();
 });
})();
